// extracted by mini-css-extract-plugin
export default {"lds_hourglass":"Loader_lds_hourglass__3Usk2"};